import type { PaymentSource } from "features/payment-methods/types";

import type { FunctionComponent, SVGProps } from "react";

import AmexIcon from "assets/icons/paymentCards/amex.svg?react";
import DinersIcon from "assets/icons/paymentCards/dinnersClub.svg?react";
import DiscoverIcon from "assets/icons/paymentCards/discover.svg?react";
import JcbIcon from "assets/icons/paymentCards/jcb.svg?react";
import MastercardIcon from "assets/icons/paymentCards/mastercard.svg?react";
import PaypalIcon from "assets/icons/paymentCards/paypal.svg?react";
import VisaIcon from "assets/icons/paymentCards/visa.svg?react";

export const CARD_ICONS: {
  [cardType: string]: FunctionComponent<SVGProps<SVGSVGElement>>;
} = {
  visa: VisaIcon,
  jcb: JcbIcon,
  american_express: AmexIcon,
  discover: DiscoverIcon,
  diners_club: DinersIcon,
  mastercard: MastercardIcon,
};

export default function PaymentSourceIcon({
  paymentSource,
}: {
  paymentSource: PaymentSource;
}) {
  const Icon =
    paymentSource.type === "card"
      ? CARD_ICONS[paymentSource.card.brand]
      : PaypalIcon;

  return (
    <div className="flex items-center justify-center w-10 h-6 border rounded-md border-black-100">
      <Icon />
    </div>
  );
}
